export const about = {
  paragraphs: [
    "I'm drawn to the small moments that make a product feel right. The pause before a button responds, the way a layout settles after a scroll, the friction that quietly disappears. I like building those moments, and I like the engineering it takes to make them feel effortless.",
    "Outside of work, I travel as often as I can. I'd rather see the world than just a screen.",
  ],
};
